import { helperTypes } from '../constants';

const initialState = {
  isMobile: false
};

export default function helper(state = initialState, action) {
  switch (action.type) {
    case helperTypes.SET_PLATFORM:
      return { ...state, isMobile: action.isMobile, isIos: action.isIos };
    case helperTypes.SET_CAMPAIGN:
      return { ...state, campaign: action.campaign };
    default:
      return state;
  }
}
